import { gql } from '@apollo/client';

export default gql`
  mutation deleteSuggestion($_id: String) {
    deleteSuggestion(_id: $_id) {
      ok
      error
    }
  }
`;
